import { Moon, Sun } from "lucide-react";
import { NavLink as NavLinkType } from "../../types";
import { NavLink } from "./NavLink";

interface MobileMenuProps {
  isOpen: boolean;
  theme: string;
  toggleTheme: () => void;
  navLinks: NavLinkType[];
  handleExternalRedirect: (url: string) => void;
}

export const MobileMenu = ({
  isOpen,
  theme,
  toggleTheme,
  navLinks,
  handleExternalRedirect,
}: MobileMenuProps) => {
  if (!isOpen) return null;

  return (
    <div className="md:hidden py-4 space-y-4">
      {navLinks.map((link) => (
        <div key={link.text} className="block px-2 py-1">
          <NavLink {...link} handleExternalRedirect={handleExternalRedirect} />
        </div>
      ))}
      <div className="px-2 py-1">
        <button
          onClick={toggleTheme}
          className="flex items-center space-x-2"
          aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
        >
          {theme === "dark" ? (
            <>
              <Sun size={20} />
              <span>Light Mode</span>
            </>
          ) : (
            <>
              <Moon size={20} />
              <span>Dark Mode</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
};